import getDataLayer from './getDataLayer';
import { IProduct } from '../../typings/IProduct';
import useGetDataByProduct from './useGetDataByProduct';
import { DL_CURRENCY, DlEcommerceEvents, DlEventSource } from './constant';

const useDataLayerViewItem = () => {
  const dataLayer = getDataLayer();
  const getDataByProduct = useGetDataByProduct();

  return (product: IProduct, dlEventSource: DlEventSource, dlItemIndex: number) => {
    const { brand, category, price } = getDataByProduct(product);

    dataLayer.push({
      event: DlEcommerceEvents.VIEW_ITEM,
      ecommerce: {
        currency: DL_CURRENCY,
        items: [
          {
            item_name: product.title,
            item_id: product.id,
            item_list_id: dlEventSource.id,
            item_list_name: dlEventSource.name,
            item_brand: brand,
            item_category: category,
            index: dlItemIndex,
            price,
          },
        ],
      },
    });
  };
};

export default useDataLayerViewItem;
